import React, {
  forwardRef,
  memo,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { useParams } from "react-router-dom";
import ReactSelect from "react-select";
import AsyncReactSelect from "react-select/async";
import CustomOption from "../CustomOption";
import { DateRangePicker } from "rsuite";

function CustomFilter(props, ref) {
  const param = useParams();

  const [text, setText] = useState("");
  const options = props.colDef?.options;
  const [data, setData] = useState({});

  const [state, setState] = useState({
    attributeSet: "",
    users: {},
  });
  const [timeout, setTimeOut] = useState("");
  const [relationType, setRelationType] = useState(props.values);

  useEffect(() => {
    setTimeout(() => {
      setRelationType(props.values);
    }, 200);
  }, [props]);
  useEffect(() => {
    setState((state) => {
      return {
        ...state,
        users: props.users,
      };
    });
  }, [props.users]);

  useImperativeHandle(ref, () => {
    return {
      isFilterActive() {
        return text !== "";
      },
      doesFilterPass(params) {
        return params.data.status === text;
      },
    };
  });

  const dateRangePicker = (evt, field) => {
    setText(evt);
    setData((state) => {
      return {
        ...state,
        [field]: Array.isArray(evt) ? evt : undefined,
      };
    });
    setState((state) => {
      return {
        ...state,
        attributeSet: Array.isArray(evt) ? evt : undefined,
      };
    });
  };

  const statusChangehandler = (evt, column = null) => {
    setText(evt);
    if (Array.isArray(evt)) {
      const iddd = evt.map((item) => item.value);

      setData((state) => {
        return {
          ...state,
          [column]: [...iddd],
        };
      });
    } else {
      setData((state) => {
        return {
          ...state,
          [evt?.target?.name || column]: evt?.target?.value || evt?.value,
        };
      });
      setState((state) => {
        return {
          ...state,
          attributeSet: evt?.target?.value || evt?.value,
        };
      });
    }
  };

  useEffect(() => {
    const id = setTimeout(() => {
      props.colDef.filterParams.filter(props, data || text);
    }, 500);

    return () => {
      clearTimeout(id);
    };
  }, [text, data]);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      wordBreak: "break-all",
    }),
    control: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        fontSize: "12px",
        textAlign: "left",
        width: "220px",
        boxShadow: "none",
      };
    },
    menuList: (styles) => {
      return {
        ...styles,
        height: "150px",
      };
    },
    menu: () => {
      return {
        boxShadow: "none",
        marginTop: "10px",
      };
    },
  };
  if (props.colDef.field === "relation_name") {
    const newoptions = relationType.map((item) => ({
      label: item.label,
      value: item.label,
    }));
    return (
      <div className="filterdiv_parent">
        <ReactSelect
          options={newoptions}
          menuIsOpen
          styles={customStyles}
          name={props.colDef.field}
          isClearable
          onChange={(evt) => statusChangehandler(evt, props.colDef.field)}
        />
      </div>
    );
  }
  if (props.colDef.field === "customer_tattle_uuid") {
    return (
      <div className="filterdiv_parent">
        <input
          type="text"
          name={"customer_tattle_uuid"}
          onChange={(evt) => statusChangehandler(evt, "customer_tattle_uuid")}
          className="form-control"
        />
      </div>
    );
  }
  if (props.colDef.field === "title") {
    return (
      <div className="filterdiv_parent">
        <input
          type="text"
          name={props.colDef.field}
          onChange={(evt) => statusChangehandler(evt, props.colDef.field)}
          className="form-control"
        />
      </div>
    );
  }
  if (props.colDef.attribute_type === "priority") {
    const { options } = props.colDef;
    let optionsnew = options.map((item) => ({
      label: item.option_name,
      value: item._id,
    }));
    return (
      <div className="filterdiv_parent">
        <ReactSelect
          options={optionsnew}
          menuIsOpen
          styles={customStyles}
          name={props.colDef.field}
          isClearable
          onChange={(evt) => statusChangehandler(evt, props.colDef.field)}
        />
      </div>
    );
  }
  if (props.colDef.attribute_type === "api") {
    const { options } = props.colDef;
    let optionsnew = options.map((item) => ({
      label: item.value,
      value: item.id,
    }));
    return (
      <div className="filterdiv_parent">
        <ReactSelect
          options={optionsnew}
          menuIsOpen
          styles={customStyles}
          name={props.colDef.field}
          isClearable
          onChange={(evt) => statusChangehandler(evt, props.colDef.field)}
        />
      </div>
    );
  }
  if (props.colDef.attribute_type === "assign_to") {
    let optionsnew;
    if (options) {
      optionsnew = Object.keys(state.users).map((key) => ({
        label: state.users[key]?.name,
        value: key,
        profile_image: state.users[key]?.profile_image,
      }));
    }
    return (
      <div className="filterdiv_parent">
        <ReactSelect
          options={optionsnew}
          menuIsOpen
          styles={customStyles}
          name={props.colDef.field}
          isClearable
          components={{ Option: CustomOption }}
          onChange={(evt) => statusChangehandler(evt, props.colDef.field)}
        />
      </div>
    );
  }
  if (props.colDef.attribute_type === "pod_department") {
    const { options } = props.colDef;

    let optionsnew = options.map((item) => ({
      label: item.value,
      value: item.id,
    }));
    return (
      <div className="filterdiv_parent">
        <ReactSelect
          options={optionsnew}
          styles={customStyles}
          menuIsOpen
          name={props.colDef.field}
          isClearable
          onChange={(evt) => statusChangehandler(evt, props.colDef.field)}
        />
      </div>
    );
  }
  if (props.colDef.attribute_type === "category") {
    const { options } = props.colDef;

    let optionsnew = options.map((item) => ({
      label: item.name,
      value: item._id,
    }));
    return (
      <div className="filterdiv_parent">
        <ReactSelect
          options={optionsnew}
          styles={customStyles}
          menuIsOpen
          name={props.colDef.field}
          isClearable
          onChange={(evt) => statusChangehandler(evt, props.colDef.field)}
        />
      </div>
    );
  }
  if (props.colDef.attribute_type === "release") {
    const { options } = props.colDef;

    let optionsnew = options.map((item) => ({
      label: item.value,
      value: item.id,
    }));
    return (
      <div className="filterdiv_parent">
        <ReactSelect
          options={optionsnew}
          styles={customStyles}
          menuIsOpen
          name={props.colDef.field}
          isClearable
          onChange={(evt) => statusChangehandler(evt, props.colDef.field)}
        />
      </div>
    );
  }
  if (
    props.colDef.attribute_type === "start_date" ||
    props.colDef.attribute_type === "end_date" ||
    props.colDef.attribute_type === "dev_start_date" ||
    props.colDef.attribute_type === "dev_end_date" ||
    props.colDef.attribute_type === "go_live_date"
  ) {
    return (
      <DateRangePicker
        onChange={(evt) => dateRangePicker(evt, props.colDef.field)}
        onClean={(evt) => dateRangePicker(evt, props.colDef.field)}
        showOneCalendar
      />
      // <input
      //   type="date"
      //   name={props.colDef.field}
      //   onChange={(evt) => statusChangehandler(evt, props.colDef.field)}
      //   className="form-control"
      // />
    );
  }

  if (props.colDef.attribute_type === "effort") {
    return (
      <div className="filterdiv_parent">
        <input
          type="text"
          name={props.colDef.field}
          onChange={(evt) => statusChangehandler(evt, props.colDef.field)}
          className="form-control"
        />
      </div>
    );
  }
  if (props.colDef.attribute_type === "status") {
    const { options } = props.colDef;

    let optionsnew = options.map((item) => ({
      label: item.name,
      value: item._id,
    }));
    return (
      <div className="filterdiv_parent">
        <ReactSelect
          options={optionsnew}
          styles={customStyles}
          menuIsOpen
          name={props.colDef.field}
          isClearable
          onChange={(evt) => statusChangehandler(evt, props.colDef.field)}
        />
      </div>
    );
  }
}

export default memo(forwardRef(CustomFilter));
